import styled from 'styled-components';

const Select = styled.select`
    /* border: 0!important; */
    border-radius: 0!important;
    padding: 12px 16px!important;
    margin: 8px 0!important;
    outline: none;
    /* background-color: #f5f5f5; */
    ::placeholder {
        color: #999;
    }
    -moz-appearance:none; /* Firefox */
	-webkit-appearance:none; /* Safari and Chrome */
	appearance:none;
	background-image: url("/img/chevron_dropdown.png")!important;
	background-repeat: no-repeat;
    background-position: right 15px center;
    background-size: 10px;
`;

export default Select;